import React, { useEffect, useState, useCallback } from 'react';
import {
    Button,
    Card, Checkbox, Col, DatePicker, Form, Input, message, Row, Badge,
    Select, Space, Switch, Tooltip, Tree, Modal, Avatar, Upload, Pagination, Table, Radio
} from 'antd';
import { usePageData } from '../../../hooks/usePage';
import { IPageData } from '../../../interfaces/page';
import { EditOutlined, DeleteOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import generalesProvider from '../../../services/generalesProvider';
import { Divider } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { useLocation, useHistory } from "react-router-dom";
import locale from 'antd/es/date-picker/locale/es_ES';
import carnetVacunacionProvider from '../../../services/carnetVacunacionProvider';
import { saveAs } from 'file-saver';
const moment = require('moment');
const { Option } = Select;
const { Search } = Input;

const pageData: IPageData = {
    fulFilled: true,
    breadcrumbs: [
        {
            title: 'Detalle Carnet Vacunación',
            route: 'edit-vacunacion'
        },
        {
            title: 'Detalle Carnet Vacunación'
        }
    ]
};
const key = 'regitrando';

const pageSize = 5;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
    return (
        <Pagination onChange={onChange} simple={true} total={total} current={current} pageSize={pageSize} />
    );
};

const EditCarnetVacunacion = () => {
    const location: any = useLocation();
    let history = useHistory();
    usePageData(pageData);
    const formItemLayout = {
        labelCol: {
            xs: {
                span: 24
            },
            sm: {
                span: 8
            }
        },
        wrapperCol: {
            xs: {
                span: 24
            },
            sm: {
                span: 16
            }
        }
    };
    const [data, setData] = useState({ data: [], totalRecords: 0 });
    const [current, setCurrent] = useState(1);
    const [isDisabled, setisDisabled] = useState(false);
    const [adjuntos, setadjuntos] = useState([]);
    const [value, setValue] = React.useState(0);
    const [form] = Form.useForm();
    const [isCheckedregunta1_1Dosis, setIsCheckedregunta1_1Dosis] = useState(false);
    const [isCheckedregunta1_2Dosis, setIsCheckedregunta1_2Dosis] = useState(false);
    const [isCheckedregunta1_3Dosis, setIsCheckedregunta1_3Dosis] = useState(false);
    const [isCheckedregunta1_Ninguno, setIsCheckedregunta1_Ninguno] = useState(false);
    const [isCheckedpregunta2_pfizer, setisCheckedpregunta2_pfizer] = useState(false);
    const [isCheckedpregunta2_aztrazeneca, setisCheckedpregunta2_aztrazeneca] = useState(false);
    const [isCheckedpregunta2_sinofarm, setisCheckedpregunta2_sinofarm] = useState(false);
    const [isCheckedpregunta2_jhonson, setisCheckedpregunta2_jhonson] = useState(false);
    const [isCheckedpregunta2_synovac, setisCheckedpregunta2_synovac] = useState(false);
    const [isCheckedpregunta2_otradistinta, setisCheckedpregunta2_otradistinta] = useState(false);

    const columns = [
        {
            title: 'Nombre Documento',
            dataIndex: 'nombrearchivo',
            key: 'nombrearchivo',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Acción',
            key: 'action',
            render: (text, record) => {
                return (
                    <Space size="middle">
                        <Button size="small" type="primary" onClick={(e) => btnDescargarDocumento(text)}>Descargar Adjuntos</Button>
                    </Space>
                )
            },
            align: 'center' as 'center',
        },
    ];

    //#region metodo de tree           
    useEffect(() => {
        if (location.state) {
            listarAdjuntoCarnetVacunacionPorIdCarnet(location.state.id);
        } else {
            history.push('/vertical/bandeja-vacunacion');
        }
    }, [current]);

    useEffect(() => {
        
        if (location.state) {
            (async () => {
                await ObtenerArchivosPorId(location.state.id);
                await listarAdjuntoCarnetVacunacionPorIdCarnet(location.state.id);
                setisDisabled(true);
                // if (location.state.idestado == 2)
                //     setisDisabled(true);
            })();
        } else {
            history.push('/vertical/bandeja-vacunacion');
        }
    }, []);

    const btnDescargarDocumento = async (data) => {
        const response = await carnetVacunacionProvider.ObtenerAdjuntoCarnetVacunacionPorId(data.id);
        saveAs(response, data.nombrearchivo);
    }

    const listarAdjuntoCarnetVacunacionPorIdCarnet = async (id) => {
        const paginacion = {
            pagenum: current,
            pagesize: pageSize,
            idCarnetVacunacion: id
        };
        const res : any = await carnetVacunacionProvider.ListarAdjuntoCarnetVacunacionPorIdCarnet(paginacion);
        if (res.data) setData(res);
    };

    const ObtenerArchivosPorId = async (id) => {
        const res = await carnetVacunacionProvider.obtenercarnetvacunacionporid({ id: id });

        setIsCheckedregunta1_1Dosis(res.data.pregunta1_1dosis);
        setIsCheckedregunta1_2Dosis(res.data.pregunta1_2dosis);
        setIsCheckedregunta1_3Dosis(res.data.pregunta1_3dosis);
        setIsCheckedregunta1_Ninguno(res.data.pregunta1_2ninguno);
        setisCheckedpregunta2_pfizer(res.data.pregunta2_pfizer);
        setisCheckedpregunta2_aztrazeneca(res.data.pregunta2_aztrazeneca);
        setisCheckedpregunta2_sinofarm(res.data.pregunta2_sinofarm);
        setisCheckedpregunta2_jhonson(res.data.pregunta2_jhonson);
        setisCheckedpregunta2_synovac(res.data.pregunta2_synovac);
        setisCheckedpregunta2_otradistinta(res.data.pregunta2_otradistinta);
        form.setFieldsValue({
            pregunta2_descripcion_otradistinta: res.data.pregunta2_descripcion_otradistinta,
            Ruc: res.data.ruc,
            RazonSocial: res.data.razonSocial,
            NombreCompleto: res.data.nombreCompleto,
            Dni: res.data.dni,
            Puesto: res.data.puesto,
            Direccion: res.data.direccion,
            Telefono: res.data.telefono,
            ContactoReferencia: res.data.contactoReferencia,
            TelefonoReferencia: res.data.telefonoReferencia,

            pregunta1_1fecha: res.data.pregunta1_1fecha,
            pregunta1_2fecha: res.data.pregunta1_2fecha,
            pregunta1_3fecha: res.data.pregunta1_3fecha,
            pregunta3_si_fecha: res.data.pregunta3_si_fecha,
            pregunta3_masdeunavez_fecha: res.data.pregunta3_masdeunavez_fecha
        }); //seteamos el   

        if (res.data.pregunta3_si)
            setValue(1);
        if (res.data.pregunta3_masdeunavez)
            setValue(2);
        if (res.data.pregunta3_no)
            setValue(3);



    }
    const CancelarCarnetVacunacion = useCallback(() => {
        history.push('/vertical/bandeja-vacunacion');
        // setShowContainerFile(false);
    }, []);

    //#endregion       

    return (
        <>
            <Card title={'Detalle Carnet Vacunación'}>
                <div className='row' >
                    <div className='col-md-12'>
                        <Form form={form}
                            labelAlign='left' layout='horizontal'>
                            <Form.Item label="Id" name="Id" noStyle>
                                <Input type="hidden" />
                            </Form.Item>
                            <div className='row'>
                                <div className='col-md-8'>
                                    <Form.Item name='RazonSocial' label='Razón social:'>
                                        <Input disabled={isDisabled} placeholder='Ingrese Razon Social..' />
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>

                                    <Form.Item name='Ruc' label='RUC:'>
                                        <Input disabled={isDisabled} placeholder='Ingrese Ruc..' />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <Form.Item name='NombreCompleto' label='Apellidos y Nombres:'>
                                        <Input disabled={isDisabled} allowClear={true} placeholder='Ingrese Apellidos y Nombres' />
                                    </Form.Item>
                                </div>
                                <div className='col-md-2'>
                                    <Form.Item name='Dni' validateStatus="validating" label='DNI:'>
                                        <Input disabled={isDisabled} placeholder='Dni' id="validating" />
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>
                                    <Form.Item name='Puesto' label='Puesto:'>
                                        <Input disabled={isDisabled} readOnly={true} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-8'>
                                    <Form.Item name='Direccion' label='Ingresa tu dirección:'>
                                        <Input disabled={isDisabled} placeholder='Ingrese Dirección...' />
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>
                                    <Form.Item name='Telefono' label='Teléfono:'>
                                        <Input disabled={isDisabled} placeholder='Ingrese Telefono' />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-8'>
                                    <Form.Item name='ContactoReferencia' label='Contacto referencia:'>
                                        <Input disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>
                                    <Form.Item name='TelefonoReferencia' label='Telefono de referencia:'>
                                        <Input disabled={isDisabled} />
                                    </Form.Item>
                                </div>
                            </div>
                            <Divider>Preguntas</Divider>
                            <div className='row'>
                                <div className='col-md-8'>
                                    <Form.Item label={'1. ¿Haz recibido la vacuna por COVID-19?'}>
                                    </Form.Item>
                                    <div className='row'>
                                        <div className='col-md-2'>
                                            <Form.Item name='pregunta1_1dosis' >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={isCheckedregunta1_1Dosis}
                                                >1 Dosis</Checkbox>
                                            </Form.Item>
                                        </div>
                                        <div className='col-md-3'>
                                            <Form.Item name="pregunta1_1fecha" label="Fecha">
                                                <Input disabled={isDisabled} />                                                
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-2'>
                                            <Form.Item name='pregunta1_2dosis' >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={isCheckedregunta1_2Dosis}
                                                >2 Dosis</Checkbox>
                                            </Form.Item>
                                        </div>
                                        <div className='col-md-3'>
                                            <Form.Item name="pregunta1_2fecha" label="Fecha"   >
                                                <Input disabled={isDisabled} />                                                
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-2'>
                                            <Form.Item name='pregunta1_2dosis' >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={isCheckedregunta1_3Dosis}
                                                >3 Dosis</Checkbox>
                                            </Form.Item>
                                        </div>
                                        <div className='col-md-3'>
                                            <Form.Item name="pregunta1_3fecha" label="Fecha"   >
                                                <Input disabled={isDisabled} />                                                
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-2'>
                                            <Form.Item name='pregunta1_2ninguno' >
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    checked={isCheckedregunta1_Ninguno}
                                                >Ninguna</Checkbox>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <Form.Item label={'2. ¿Con que vacuna le realizaron la inmunización?'}>
                                    </Form.Item>
                                    <Form.Item name='pregunta2_pfizer' >
                                        <Checkbox disabled={isDisabled} checked={isCheckedpregunta2_pfizer}>Pfizer</Checkbox>
                                    </Form.Item>
                                    <Form.Item name='pregunta2_aztrazeneca' >
                                        <Checkbox disabled={isDisabled} checked={isCheckedpregunta2_aztrazeneca}>AztraZeneca</Checkbox>
                                    </Form.Item>
                                    <Form.Item name='pregunta2_sinofarm' >
                                        <Checkbox disabled={isDisabled} checked={isCheckedpregunta2_sinofarm}>Sinofarm</Checkbox>
                                    </Form.Item>
                                    <Form.Item name='pregunta2_jhonson' >
                                        <Checkbox disabled={isDisabled} checked={isCheckedpregunta2_jhonson}>Jhonson & Jhonson</Checkbox>
                                    </Form.Item>
                                    <Form.Item name='pregunta2_synovac' >
                                        <Checkbox disabled={isDisabled} checked={isCheckedpregunta2_synovac}>Synovac</Checkbox>
                                    </Form.Item>
                                    <div className='row'>
                                        <div className='col-md-2'>
                                            <Form.Item name='pregunta2_otradistinta' >
                                                <Checkbox disabled={isDisabled} checked={isCheckedpregunta2_otradistinta}>Otra distinta especificar: </Checkbox>
                                            </Form.Item>
                                        </div>
                                        <div className='col-md-4'>
                                            <Form.Item name="pregunta2_descripcion_otradistinta">
                                                <Input.TextArea placeholder='Descripción' rows={2} disabled={isDisabled} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <Form.Item label={'3. ¿Le ha dado COVID-19 confirmado anteriormente?'}>
                                    </Form.Item>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <Radio.Group value={value}>
                                                <Space direction="vertical">
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <Radio value={1} disabled={isDisabled} >Sí, una sola vez</Radio>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <Form.Item name="pregunta3_si_fecha" label="Fecha" rules={value == 1 ? [{ required: true, message: 'Fecha es requerido!' }] : null} >
                                                                {/* <DatePicker placeholder={'dd/mm/yyyy'} locale={locale} format={'DD/MM/yyyy'} /> */}
                                                                <Input disabled={isDisabled} />
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                    <Row>
                                                        <Col span={12}>
                                                            <Radio value={2} disabled={isDisabled} >Sí, más de una vez</Radio>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item name="pregunta3_masdeunavez_fecha" label="Fecha de la ultima re infección" rules={value == 2 ? [{ required: true, message: 'Fecha es requerido!' }] : null} >
                                                                {/* <DatePicker placeholder={'dd/mm/yyyy'} locale={locale} format={'DD/MM/yyyy'} /> */}
                                                                <Input disabled={isDisabled} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={12}>
                                                            <Radio disabled={isDisabled} value={3} >No he tenido Covid</Radio>
                                                        </Col>
                                                    </Row>
                                                </Space>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <Form.Item >
                                        Todos los datos expresados en esta ficha constituyen declaración jurada de mi parte.<br />
                                        He sido informado que de omitir o declarar información falsa puedo perjudicar la salud de mis compañeros y la mía propia, asumiendo las responsabilidades que correspondan.<br />
                                        Autorizo a la empresa el adecuado uso de los datos consignados en la presente declaración jurada de acuerdo a lo establecido en la Ley N° 29733.
                                    </Form.Item>
                                </div>
                                <div className='col-md-4'>
                                    <Table locale={{ emptyText: 'No existen registros' }} pagination={false} columns={columns} dataSource={data.data}
                                        bordered />
                                    <Row justify={'center'}>
                                        <Col>
                                            <PaginacionPersonalizada total={data.totalRecords} current={current} onChange={setCurrent} />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <Form.Item>
                                        <Button
                                            // loading={cargando} disabled={restringido} 
                                            type='primary' onClick={CancelarCarnetVacunacion} > Cancelar</Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </Card>
        </>
    );
};
export default EditCarnetVacunacion;